var sizes = {
  s: 16,
  m: 24,
  l: 32,
  xl: 40
};
var iconSizes = {
  "ic_accident-end": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  ic_accident: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  ic_ad: {
    xl: [32, 32],
    l: [24, 21],
    m: [18, 15.72],
    s: [12, 10]
  },
  "ic_add-circle-outline": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_add-circle": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_add-photo": {
    xl: [32, 32],
    l: [29, 26],
    m: [21.24, 19.44],
    s: [15.2, 13]
  },
  "ic_add-plus": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_add-user": {
    xl: [32, 32],
    l: [27.5, 20],
    m: [20, 15],
    s: [14, 10]
  },
  "ic_alarm-clock": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_alert: {
    xl: [32, 32],
    l: [24, 20],
    m: [18, 15.51],
    s: [12, 10]
  },
  ic_alfa: {
    xl: [32, 32],
    l: [20, 28],
    m: [14, 20],
    s: [10, 14]
  },
  ic_apple: {
    xl: [32, 32],
    l: [19.5, 24],
    m: [15, 18],
    s: [10, 12]
  },
  "ic_archive-border": {
    xl: [32, 32],
    l: [26, 20],
    m: [20, 16],
    s: [14, 10]
  },
  ic_archive: {
    xl: [32, 32],
    l: [26, 20],
    m: [20, 16],
    s: [14, 10]
  },
  ic_arrest: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  "ic_arrow-breadcrumbs": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  "ic_arrow-down": {
    xl: [32, 32],
    l: [25.84, 16.06],
    m: [19.17, 11.94],
    s: [13.17, 8.24]
  },
  "ic_arrow-left-bold": {
    xl: [32, 32],
    l: [17, 28],
    m: [12.36, 20],
    s: [8.65, 14]
  },
  "ic_arrow-right-bold": {
    xl: [32, 32],
    l: [17, 28],
    m: [12.36, 20],
    s: [8.65, 14]
  },
  "ic_arrow-triangle-down": {
    xl: [32, 32],
    l: [20, 10],
    m: [15, 7.5],
    s: [10, 5]
  },
  "ic_arrow-triangle-up": {
    xl: [32, 32],
    l: [20, 10],
    m: [15, 7.5],
    s: [10, 5]
  },
  "ic_arrow-up": {
    xl: [32, 32],
    l: [25.84, 16.06],
    m: [19.17, 11.94],
    s: [13.17, 8.24]
  },
  ic_arrows: {
    xl: [32, 32],
    l: [20.26, 30],
    m: [15, 20],
    s: [10, 13.33]
  },
  "ic_ati-docs": {
    xl: [36, 28.29],
    l: [28, 22],
    m: [20, 16.56],
    s: [14, 10.89]
  },
  "ic_ati-docs-colorless": {
    xl: [32, 32],
    l: [28, 22],
    m: [20, 15.56],
    s: [14, 10.89]
  },
  "ic_ati-logo-horizontal-rus": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  "ic_ati-logo-horizontal": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  "ic_ati-logo-icon": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_ati-logo-vertical": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  "ic_ati-logo": {
    xl: [32, 32],
    l: [30, 30],
    m: [20, 20],
    s: [10, 10]
  },
  "ic_ati-pointer": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_attachment: {
    xl: [32, 32],
    l: [22.5, 24],
    m: [17, 18],
    s: [12, 12]
  },
  "ic_auto-train": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // cant contain
  "ic_bank-card": {
    xl: [32, 32],
    l: [28, 20],
    m: [20, 14.3],
    s: [14, 10]
  },
  ic_beeline: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_bell: {
    xl: [32, 32],
    l: [20, 23.5],
    m: [16, 19],
    s: [10, 12]
  },
  ic_bill: {
    xl: [32, 32],
    l: [18, 23.9],
    m: [14, 17.94],
    s: [10, 11.94]
  },
  ic_block: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_boards: {
    xl: [32, 32],
    l: [25.21, 30.98],
    m: [18, 22.12],
    s: [12.92, 15.88]
  },
  ic_bold: {
    xl: [32, 32],
    l: [20, 26],
    m: [15, 20],
    s: [9, 12]
  },
  ic_breakdown: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  ic_burger: {
    xl: [32, 32],
    l: [28, 20],
    m: [20, 14],
    s: [14, 10]
  },
  ic_bus: {
    xl: [32, 32],
    l: [26, 18],
    m: [20, 14],
    s: [14, 10]
  },
  ic_calendar: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  ic_camera: {
    xl: [32, 32],
    l: [28, 22.5],
    m: [20, 16.5],
    s: [14, 11]
  },
  ic_cargo: {
    xl: [32, 32],
    l: [20, 22.77],
    m: [16, 18.21],
    s: [10, 11.38]
  },
  "ic_cargo-out": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  ic_case: {
    xl: [32, 32],
    l: [24, 21.5],
    m: [18, 16],
    s: [11, 10]
  },
  ic_cash: {
    xl: [32, 32],
    l: [15, 28],
    m: [10.5, 20],
    s: [7, 14]
  },
  ic_center: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_charts: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_chain: {
    xl: [32, 32],
    l: [32, 32],
    m: [24, 24],
    s: [16, 16]
  },
  "ic_check-all": {
    xl: [32, 32],
    l: [28, 15.4],
    m: [20, 11],
    s: [16, 8.8]
  },
  "ic_check-bold": {
    xl: [32, 32],
    l: [27, 20],
    m: [20, 14],
    s: [14, 10]
  },
  "ic_check-thin": {
    xl: [32, 32],
    l: [27, 20],
    m: [20, 15],
    s: [14, 10]
  },
  "ic_circle-dots": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_clock: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_close-bold": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_close: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_cog: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_coins: {
    xl: [32, 32],
    l: [20, 22],
    m: [16, 18],
    s: [10, 11]
  },
  "ic_comment-badge": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_comment: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_commenting: {
    xl: [32, 32],
    l: [24, 20.14],
    m: [18, 15],
    s: [12, 10]
  },
  ic_company: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_container-loading": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  "ic_container-resieved": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  "ic_container-unloading": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  ic_container: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  ic_contragent: {
    xl: [32, 32],
    l: [22, 24],
    m: [18, 19],
    s: [12, 12]
  },
  ic_copy: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_cup: {
    xl: [27.83, 32],
    l: [20.87, 24],
    m: [16, 18],
    s: [10.48, 12]
  },
  ic_customs: {
    xl: [32, 32],
    l: [28, 24],
    m: [18, 15],
    s: [14, 12]
  },
  "ic_delete-outline": {
    xl: [32, 32],
    l: [20, 21.82],
    m: [16.5, 18],
    s: [11, 12]
  },
  ic_delete: {
    xl: [32, 32],
    l: [20, 25.77],
    m: [15.5, 20],
    s: [10, 12.89]
  },
  ic_doc: {
    xl: [32, 32],
    l: [20, 25],
    m: [16, 20],
    s: [11, 14]
  },
  ic_dot: {
    xl: [32, 32],
    l: [16, 16],
    m: [12, 12],
    s: [8, 8]
  },
  ic_dots: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  "ic_download-bold": {
    xl: [32, 32],
    l: [20, 24],
    m: [16, 20],
    s: [12, 14]
  },
  "ic_download-thin": {
    xl: [32, 32],
    l: [20, 28],
    m: [14, 20],
    s: [10, 14]
  },
  "ic_discount-out": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_dzen-white": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_dzen: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_edit-box": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_edit: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_ellipsis: {
    xl: [32, 32],
    l: [28, 6.5],
    m: [20, 4],
    s: [14, 3.23]
  },
  "ic_error-summary": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  ic_error: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_exchange: {
    xl: [32, 32],
    l: [26, 20],
    m: [20, 15],
    s: [13, 10]
  },
  ic_external: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_eye: {
    xl: [32, 32],
    l: [26, 14],
    m: [19.18, 10.43],
    s: [13.19, 7.29]
  },
  "ic_facebook-white": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_facebook: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_fb-logo": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_filter-out": {
    xl: [32, 32],
    l: [23.5, 20],
    m: [17.5, 15],
    s: [11.5, 9]
  },
  ic_finish: {
    xl: [32, 32],
    l: [20, 24],
    m: [15, 18],
    s: [10, 12]
  },
  ic_firm: {
    xl: [32, 32],
    l: [24, 22],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_flag-armenia": {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9]
  },
  "ic_flag-by": {
    xl: [32, 32],
    l: [29, 19],
    m: [21, 13],
    s: [15, 9]
  },
  "ic_flag-en": {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9]
  },
  "ic_flag-estonia": {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9]
  },
  "ic_flag-kyrgyzstan": {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9]
  },
  "ic_flag-kz": {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9]
  },
  "ic_flag-other": {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9]
  },
  "ic_flag-poland": {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9]
  },
  "ic_flag-ru-border": {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9]
  },
  "ic_flag-ru": {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9]
  },
  "ic_flag-ua": {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9]
  },
  "ic_flag-uzbekistan": {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9]
  },
  ic_globe: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  "ic_green-truck": {
    xl: [31.3, 30],
    l: [23, 22],
    m: [16.73, 16],
    s: [12.55, 12]
  },
  ic_hide: {
    xl: [32, 32],
    l: [28, 24],
    m: [21.99, 20],
    s: [14, 12]
  },
  ic_history: {
    xl: [32, 32],
    l: [26, 22.29],
    m: [21, 18],
    s: [14, 12]
  },
  ic_human: {
    xl: [32, 32],
    l: [24, 24],
    m: [16, 16],
    s: [10, 10]
  },
  ic_humans: {
    xl: [32, 32],
    l: [26, 20],
    m: [20, 15],
    s: [14, 11]
  },
  ic_icq: {
    xl: [32, 32],
    l: [27, 28],
    m: [20, 20.77],
    s: [13.5, 14]
  },
  ic_image: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_information-solid": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_information: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_instagram-logo": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_instagram-white": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_instagram: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_italic: {
    xl: [32, 32],
    l: [17, 26],
    m: [13, 20],
    s: [8, 12]
  },
  ic_lens: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_light: {
    xl: [32, 32],
    l: [28, 25],
    m: [20, 18],
    s: [15, 14]
  },
  ic_link: {
    xl: [32, 32],
    l: [28, 14],
    m: [20, 10],
    s: [14, 7]
  },
  ic_list: {
    xl: [32, 32],
    l: [28, 20],
    m: [20, 14],
    s: [14, 10]
  },
  ic_load: {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9]
  },
  ic_loading: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  "ic_loads-search": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_location-city": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  ic_lock: {
    xl: [32, 32],
    l: [21, 28],
    m: [16, 20],
    s: [10, 13]
  },
  ic_mail: {
    xl: [32, 32],
    l: [26.5, 20],
    m: [20, 15],
    s: [14, 10.5]
  },
  "ic_map-move": {
    xl: [32, 32],
    l: [18, 28.35],
    m: [13.33, 21],
    s: [8, 12.6]
  },
  "ic_map-pin": {
    xl: [32, 32],
    l: [20, 28],
    m: [14, 20],
    s: [10, 14]
  },
  "ic_mastercard-descr": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // cant contain
  ic_mastercard: {
    xl: [32, 32],
    l: [28, 17.7],
    m: [19.79, 12.55],
    s: [14, 9]
  },
  ic_megafon: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_megaphone: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_message-solid": {
    xl: [32, 32],
    l: [22, 22],
    m: [16.5, 16],
    s: [11, 10.67]
  },
  ic_message: {
    xl: [32, 32],
    l: [22, 22],
    m: [16.5, 16],
    s: [11, 10.67]
  },
  ic_messenger: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_mic: {
    xl: [32, 32],
    l: [18.67, 25.33],
    m: [14, 19],
    s: [9.33, 12.67]
  },
  ic_minus: {
    xl: [32, 32],
    l: [14.59, 2.34],
    m: [11, 2],
    s: [8, 2]
  },
  ic_movizor: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  ic_mts: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_mute: {
    xl: [32, 32],
    l: [25, 20],
    m: [20, 16],
    s: [12, 10]
  },
  ic_necktie: {
    xl: [26, 33],
    l: [21, 27],
    m: [16, 21],
    s: [10, 13]
  },
  "ic_new-badge": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  ic_new: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  "ic_no-eye": {
    xl: [32, 32],
    l: [27.32, 14],
    m: [20.08, 10.43],
    s: [13.38, 7.29]
  },
  ic_none: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_note: {
    xl: [32, 32],
    l: [24, 22.15],
    m: [17, 16],
    s: [11, 10]
  },
  ic_notification: {
    xl: [32, 32],
    l: [20.08, 22],
    m: [14.61, 16],
    s: [10.04, 11]
  },
  "ic_numbered-list": {
    xl: [32, 32],
    l: [26.84, 20],
    m: [20.13, 15],
    s: [13.42, 10]
  },
  "ic_ok-white": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_ok: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_pager: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_paper: {
    xl: [32, 32],
    l: [20, 24],
    m: [17, 20],
    s: [10, 12]
  },
  ic_parking: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  ic_pause: {
    xl: [32, 32],
    l: [16, 18.67],
    m: [12, 14],
    s: [8, 9.33]
  },
  ic_percent: {
    xl: [32, 32],
    l: [22, 14],
    m: [16.5, 10.5],
    s: [11, 7]
  },
  ic_phone: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_pin-tilted-outline": {
    xl: [32, 32],
    l: [19.2, 24],
    m: [14.4, 18],
    s: [11.2, 14]
  },
  "ic_pin-tilted": {
    xl: [32, 32],
    l: [19.2, 24],
    m: [14.4, 18],
    s: [11.2, 14]
  },
  ic_pin: {
    xl: [32, 32],
    l: [19, 28],
    m: [14, 20],
    s: [10, 14]
  },
  ic_place: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_play-market": {
    xl: [32, 32],
    l: [22.14, 24],
    m: [17, 18],
    s: [11.09, 12]
  },
  ic_play: {
    xl: [32, 32],
    l: [14.67, 18.67],
    m: [11, 14],
    s: [7.33, 9.33]
  },
  "ic_plus-solid": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  ic_plus: {
    xl: [32, 32],
    l: [18.4, 18.31],
    m: [14, 14],
    s: [10, 10]
  },
  "ic_point-load": {
    xl: [32, 32],
    l: [26, 21],
    m: [20, 16],
    s: [13, 10]
  },
  "ic_point-unload": {
    xl: [32, 32],
    l: [26, 21],
    m: [20, 16],
    s: [13, 10]
  },
  "ic_pointer-arrow-down": {
    xl: [32, 32],
    l: [16, 20],
    m: [12, 16],
    s: [8, 10]
  },
  "ic_pointer-arrow-left": {
    xl: [32, 32],
    l: [20, 16],
    m: [16, 12],
    s: [10, 8]
  },
  "ic_pointer-arrow-right": {
    xl: [32, 32],
    l: [20, 16],
    m: [16, 12],
    s: [10, 8]
  },
  "ic_pointer-arrow-up": {
    xl: [32, 32],
    l: [16, 20],
    m: [12, 16],
    s: [8, 10]
  },
  ic_preloader: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_print: {
    xl: [32, 32],
    l: [24, 21],
    m: [18, 16],
    s: [12, 10]
  },
  ic_prohibited: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_protect: {
    xl: [32, 32],
    l: [20, 25],
    m: [16, 20],
    s: [10, 12]
  },
  ic_qiwi: {
    xl: [32, 32],
    l: [26.8, 28],
    m: [19.3, 20],
    s: [13.4, 14]
  },
  "ic_question-out": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_question-solid": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_rec: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_refresh: {
    xl: [32, 32],
    l: [20.8, 26],
    m: [16, 20],
    s: [10, 12.5]
  },
  "ic_rep-signal-gray": {
    xl: [32, 32],
    l: [25.6, 25.6],
    m: [19.2, 19.2],
    s: [12.8, 12.8]
  },
  "ic_rep-signal-green": {
    xl: [32, 32],
    l: [25.6, 25.6],
    m: [19.2, 19.2],
    s: [12.8, 12.8]
  },
  "ic_rep-signal-light": {
    xl: [32, 32],
    l: [25.6, 25.6],
    m: [19.2, 19.2],
    s: [12.8, 12.8]
  },
  "ic_rep-signal-red": {
    xl: [32, 32],
    l: [25.6, 25.6],
    m: [19.2, 19.2],
    s: [12.8, 12.8]
  },
  "ic_rep-signal-yellow": {
    xl: [32, 32],
    l: [25.6, 25.6],
    m: [19.2, 19.2],
    s: [12.8, 12.8]
  },
  ic_requisites: {
    xl: [32, 32],
    l: [22, 24],
    m: [16, 18],
    s: [10, 11]
  },
  ic_ribbon: {
    xl: [29.33, 32],
    l: [22, 24],
    m: [16, 18],
    s: [10, 11.18]
  },
  ic_rostelecom: {
    xl: [32, 32],
    l: [17.4, 28],
    m: [12.45, 20],
    s: [8.7, 14]
  },
  ic_roubles: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_saved-search": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_sber: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_sberbank: {
    xl: [32, 32],
    l: [28, 26.8],
    m: [20, 19.6],
    s: [14, 13.4]
  },
  ic_sbp: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_sbp-white": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_search-people": {
    xl: [32, 32],
    l: [22.66, 22.66],
    m: [16.24, 16.24],
    s: [11.53, 11.53]
  },
  ic_send: {
    xl: [32, 32],
    l: [25, 20],
    m: [20, 16],
    s: [14, 11]
  },
  ic_shape: {
    xl: [32, 32],
    l: [24.5, 20],
    m: [18, 14],
    s: [12, 10]
  },
  ic_share: {
    xl: [32, 32],
    l: [21, 24],
    m: [16, 18],
    s: [10, 11]
  },
  ic_show: {
    xl: [32, 32],
    l: [28, 20],
    m: [22, 16],
    s: [14, 10]
  },
  ic_skype: {
    xl: [32, 32],
    l: [24, 23.61],
    m: [18, 17.8],
    s: [12, 11.8]
  },
  "ic_smile-outline": {
    xl: [32, 32],
    l: [26.67, 26.67],
    m: [20, 20],
    s: [13.33, 13.33]
  },
  ic_smile: {
    xl: [32, 32],
    l: [26.67, 26.67],
    m: [20, 20],
    s: [13.33, 13.33]
  },
  "ic_sound-off": {
    xl: [32, 32],
    l: [22, 24],
    m: [16, 18],
    s: [11, 12]
  },
  ic_sound: {
    xl: [32, 32],
    l: [16, 24],
    m: [12, 18],
    s: [8, 12]
  },
  ic_speaker: {
    xl: [32, 32],
    l: [27.5, 22],
    m: [20, 16],
    s: [14, 11]
  },
  ic_special: {
    xl: [32, 32],
    l: [24, 23],
    m: [18, 17.25],
    s: [12, 11.5]
  },
  "ic_star-medal": {
    xl: [31.17, 34],
    l: [22, 24],
    m: [16, 18],
    s: [11, 12]
  },
  "ic_star-outline": {
    xl: [32, 30.67],
    l: [24, 23],
    m: [18, 17],
    s: [12, 11]
  },
  ic_star: {
    xl: [32, 30.67],
    l: [24, 23],
    m: [18, 17],
    s: [12, 11]
  },
  ic_status: {
    xl: [32, 32],
    l: [16, 16],
    m: [12, 12],
    s: [8, 8]
  },
  ic_stop: {
    xl: [32, 32],
    l: [16, 16],
    m: [12, 12],
    s: [8, 8]
  },
  "ic_success-outline": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_success: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_tele2: {
    xl: [32, 32],
    l: [26.67, 10],
    m: [20, 7.5],
    s: [13.33, 5]
  },
  "ic_telegram-logo": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_thumb-down": {
    xl: [32, 32],
    l: [24, 22],
    m: [18, 17],
    s: [12, 11.33]
  },
  "ic_thumb-up": {
    xl: [32, 32],
    l: [24, 22],
    m: [18, 17],
    s: [12, 11.33]
  },
  "ic_timer-out": {
    xl: [32, 32],
    l: [17, 28],
    m: [12, 20],
    s: [9, 14]
  },
  "ic_timer-solid": {
    xl: [32, 32],
    l: [17, 28],
    m: [12, 20],
    s: [9, 14]
  },
  "ic_to-bill": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_traffic-gray": {
    xl: [36.43, 34],
    l: [29.14, 27.2],
    m: [21.86, 20.4],
    s: [14.58, 13.6]
  },
  "ic_traffic-green": {
    xl: [36.43, 34],
    l: [29.14, 27.2],
    m: [21.86, 20.4],
    s: [14.58, 13.6]
  },
  "ic_traffic-light": {
    xl: [22, 36],
    l: [17, 28],
    m: [12, 20],
    s: [8, 14]
  },
  "ic_traffic-white": {
    xl: [39, 39],
    l: [31.2, 31.2],
    m: [23.4, 23.4],
    s: [15.6, 15.6]
  },
  "ic_traffic-red": {
    xl: [36.43, 34],
    l: [29.14, 27.2],
    m: [21.86, 20.4],
    s: [14.58, 13.6]
  },
  "ic_traffic-yellow": {
    xl: [36.43, 34],
    l: [29.14, 27.2],
    m: [21.86, 20.4],
    s: [14.58, 13.6]
  },
  ic_trailer: {
    xl: [32, 32],
    l: [28, 13],
    m: [20, 9.5],
    s: [14, 6.6]
  },
  "ic_truck-cabin": {
    xl: [32, 32],
    l: [24, 22],
    m: [18, 16],
    s: [12, 10.98]
  },
  "ic_truck-front": {
    xl: [32, 32],
    l: [20, 21.37],
    m: [13.15, 13.5],
    s: [10, 10.5]
  },
  "ic_truck-new": {
    xl: [32, 32],
    l: [26, 20.67],
    m: [20, 16],
    s: [12.5, 10]
  },
  ic_truck: {
    xl: [32, 32],
    l: [24, 20],
    m: [19, 16],
    s: [12, 10]
  },
  ic_underline: {
    xl: [32, 32],
    l: [19, 26],
    m: [14, 20],
    s: [9, 12]
  },
  ic_unload: {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 13.17]
  },
  ic_unloading: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // nf
  "ic_upload-bold": {
    xl: [32, 32],
    l: [20, 24],
    m: [16, 20],
    s: [12, 14]
  },
  "ic_upload-thin": {
    xl: [32, 32],
    l: [20, 28],
    m: [14, 20],
    s: [10, 14]
  },
  ic_van: {
    xl: [32, 32],
    l: [28, 20],
    m: [20, 14],
    s: [12, 8.4]
  },
  ic_via: {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_viber-logo": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_visa-descr": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  // cant contain
  "ic_visa-descr-white": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_visa: {
    xl: [32, 32],
    l: [28, 9],
    m: [20, 6.43],
    s: [14, 4.5]
  },
  "ic_visa-white": {
    xl: [32, 32],
    l: [28, 9],
    m: [20, 6.43],
    s: [14, 4.5]
  },
  "ic_vk-logo": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_vk-white": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_vk: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_wagon: {
    xl: [32, 32],
    l: [28, 20],
    m: [20, 14],
    s: [14, 10]
  },
  ic_warning: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_web-money": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_whatsapp-logo": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_winner-badge": {
    xl: [25.6, 32],
    l: [19.2, 24],
    m: [14.4, 18],
    s: [9.6, 12]
  },
  "ic_yandex-maps": {
    xl: [32, 32],
    l: [21.33, 26.67],
    m: [16, 20],
    s: [10.67, 13.33]
  },
  "ic_yandex-money": {
    xl: [32, 32],
    l: [19, 24],
    m: [16, 20],
    s: [11, 14]
  },
  "ic_yoo-money": {
    xl: [32, 32],
    l: [28, 19.6],
    m: [20, 14],
    s: [14, 9.7]
  },
  "ic_youtube-logo": {
    xl: [32, 32],
    l: [24, 18.67],
    m: [18, 14],
    s: [12, 9.33]
  },
  "ic_youtube-white": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  ic_youtube: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_zen-logo": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_truck-out": {
    xl: [32, 32],
    l: [30, 24],
    m: [21, 18],
    s: [16, 13]
  },
  "ic_del-out": {
    xl: [32, 32],
    l: [21, 21],
    m: [16, 17],
    s: [12, 13]
  },
  "ic_schedule-out": {
    xl: [32, 32],
    l: [21, 21],
    m: [17, 17],
    s: [13, 13]
  },
  "ic_orders-from-you-out-down": {
    xl: [32, 32],
    l: [21, 21],
    m: [17, 17],
    s: [13, 13]
  },
  "ic_orders-to-you-out-down": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_orders-from-you-out": {
    xl: [32, 32],
    l: [21, 21],
    m: [17, 17],
    s: [13, 13]
  },
  "ic_orders-to-you-out": {
    xl: [32, 32],
    l: [21, 21],
    m: [17, 17],
    s: [13, 13]
  },
  "ic_mini-arrow": {
    xl: [32, 32],
    l: [10, 6],
    m: [9, 6],
    s: [7, 5]
  },
  ic_services: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [15, 14]
  },
  "ic_arrow-left-out": {
    xl: [32, 32],
    l: [11, 21],
    m: [9, 17],
    s: [7, 13]
  },
  "ic_chart-out": {
    xl: [32, 32],
    l: [21, 23],
    m: [18, 19],
    s: [13, 13]
  },
  "ic_location-out": {
    xl: [32, 32],
    l: [21, 21],
    m: [17, 17],
    s: [13, 13]
  },
  "ic_search-out": {
    xl: [32, 32],
    l: [21, 21],
    m: [17, 17],
    s: [13, 13]
  },
  "ic_refresh-out": {
    xl: [32, 32],
    l: [25.5, 25.5],
    m: [17.5, 17.5],
    s: [11.5, 11.5]
  },
  "ic_edit-out": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_copy-out": {
    xl: [32, 32],
    l: [23.5, 23.5],
    m: [17.5, 17.5],
    s: [11.5, 11.5]
  },
  "ic_saved-search-out": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_history-out": {
    xl: [32, 32],
    l: [28.5, 25.5],
    m: [19.87, 18],
    s: [13, 12]
  },
  "ic_close-out": {
    xl: [32, 32],
    l: [19.5, 19.5],
    m: [13.5, 13.5],
    s: [9.5, 9.5]
  },
  "ic_star-out": {
    xl: [30, 28.5],
    l: [22, 21.5],
    m: [18, 17],
    s: [12, 11.5]
  },
  "ic_star-filled-out": {
    xl: [30, 28.5],
    l: [22, 21.5],
    m: [18, 17],
    s: [12, 11.5]
  },
  "ic_lot-disunion": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_eye-out": {
    xl: [32, 32],
    l: [28.08, 20.43],
    m: [20.08, 14.71],
    s: [14.08, 10.43]
  },
  "ic_arrow-up-out": {
    xl: [32, 32],
    l: [20, 10],
    m: [16, 8],
    s: [12, 6]
  },
  "ic_check-out": {
    xl: [32, 32],
    l: [20, 15.5],
    m: [12, 9.5],
    s: [8, 6.5]
  },
  "ic_empty-out": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_eye-closed-out": {
    xl: [32, 32],
    l: [28.8, 22.2],
    m: [20.08, 15.95],
    s: [14.08, 11.27]
  },
  "ic_arrow-right-out": {
    xl: [32, 32],
    l: [10, 20],
    m: [8, 16],
    s: [6, 12]
  },
  "ic_round-check-out": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_arrow-down-out": {
    xl: [32, 32],
    l: [20, 10],
    m: [16, 8],
    s: [12, 6]
  },
  "ic_lens-out": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_alert-out": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_archive-out": {
    xl: [32, 32],
    l: [22.55, 20],
    m: [18, 16],
    s: [13.45, 12]
  },
  "ic_computer-out": {
    xl: [32, 32],
    l: [24.5, 22.5],
    m: [18.75, 17.25],
    s: [13, 12]
  },
  "ic_orders-out": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_dock-filled-out": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_active-session-out": {
    xl: [32, 32],
    l: [24.5, 24.5],
    m: [18.75, 18.75],
    s: [12.5, 12.5]
  },
  "ic_notification-message-out": {
    xl: [32, 32],
    l: [23.15, 24.5],
    m: [17.74, 18.75],
    s: [12.32, 13]
  },
  "ic_scan-out": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_calc-out": {
    xl: [32, 32],
    l: [22, 21.79],
    m: [18, 17.83],
    s: [11.26, 11.38]
  },
  "ic_flag-out": {
    xl: [32, 32],
    l: [18, 24],
    m: [13, 18],
    s: [9.5, 13.5]
  },
  "ic_income-out": {
    xl: [32, 32],
    l: [19.5, 20],
    m: [16, 16.49],
    s: [11.5, 12]
  },
  "ic_outgoing-out": {
    xl: [32, 32],
    l: [19.5, 20],
    m: [16, 16.49],
    s: [11.5, 12]
  },
  "ic_clock-out": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_draft-out": {
    xl: [32, 32],
    l: [20, 17.5],
    m: [18, 15.5],
    s: [11.5, 10]
  },
  "ic_user-out": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_mobile-out": {
    xl: [32, 32],
    l: [17.4, 22.7],
    m: [13.42, 17.4],
    s: [9.45, 12.1]
  },
  "ic_shield-out": {
    xl: [32, 32],
    l: [18.37, 23.5],
    m: [14.16, 18],
    s: [9.94, 12.5]
  },
  "ic_burger-out": {
    xl: [32, 32],
    l: [25.5, 15.5],
    m: [19.5, 11.5],
    s: [11.5, 7.5]
  },
  "ic_add-out": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_mobile-devices-out": {
    xl: [32, 32],
    l: [19.5, 24.5],
    m: [15, 18.75],
    s: [10.5, 13]
  },
  "ic_rouble-out": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_route-out": {
    xl: [32, 32],
    l: [23.5, 23.5],
    m: [19, 19],
    s: [11.5, 11.5]
  },
  "ic_exit-in": {
    xl: [32, 32],
    l: [19.75, 20],
    m: [15.5, 16],
    s: [9.84, 10]
  },
  "ic_exit-out": {
    xl: [32, 32],
    l: [19.75, 20],
    m: [15.5, 16],
    s: [9.84, 10]
  },
  "ic_count-out": {
    xl: [32, 32],
    l: [24, 24],
    m: [18.07, 18],
    s: [12.2, 12]
  },
  "ic_coin-out": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_car-rent-out": {
    xl: [32, 32],
    l: [22, 25],
    m: [16, 18.3],
    s: [12, 13.5]
  },
  "ic_truck-buy-out": {
    xl: [32, 32],
    l: [28, 22.75],
    m: [20.01, 16.75],
    s: [14, 12.25]
  },
  "ic_order-buy-out": {
    xl: [32, 32],
    l: [18, 21.25],
    m: [15, 17.5],
    s: [11, 12]
  },
  "ic_order-rent-out": {
    xl: [32, 32],
    l: [18, 21.25],
    m: [15, 17.44],
    s: [11, 12]
  },
  "ic_ads-out": {
    xl: [32, 32],
    l: [20, 20.5],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_wallet-out": {
    xl: [32, 32],
    l: [21, 20],
    m: [17, 16],
    s: [12.5, 12]
  },
  "ic_hands-out": {
    xl: [32, 32],
    l: [28, 18],
    m: [20, 13],
    s: [14, 9.5]
  },
  "ic_banknote-out": {
    xl: [32, 32],
    l: [25, 20],
    m: [20, 16],
    s: [12, 10.5]
  },
  "ic_card-out": {
    xl: [32, 32],
    l: [25, 20],
    m: [18, 16],
    s: [12.5, 12]
  },
  "ic_mail-2-out": {
    xl: [32, 32],
    l: [25, 20],
    m: [20, 16],
    s: [12, 10]
  },
  "ic_my-board-out": {
    xl: [32, 32],
    l: [24, 24],
    m: [17.5, 17.5],
    s: [12, 12]
  },
  "ic_open-board-out": {
    xl: [32, 32],
    l: [21, 22],
    m: [15.5, 16],
    s: [11.5, 12]
  },
  "ic_copy-board-out": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_tender-out": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_part-board-out": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_phone-out": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  ic_gosuslugi: {
    xl: [32, 32],
    l: [26, 28],
    m: [19, 20],
    s: [13, 14]
  },
  ic_hryvnia: {
    xl: [32, 32],
    l: [21.36, 26],
    m: [16.02, 19.5],
    s: [10.68, 13]
  },
  ic_lari: {
    xl: [32, 32],
    l: [24, 26.67],
    m: [18, 20],
    s: [12, 13.33]
  },
  ic_rouble: {
    xl: [32, 32],
    l: [17.14, 24],
    m: [12.86, 18],
    s: [8.57, 12]
  },
  ic_dram: {
    xl: [32, 32],
    l: [23, 26],
    m: [16, 18],
    s: [11, 12]
  },
  ic_euro: {
    xl: [32, 32],
    l: [24.61, 26],
    m: [18.45, 19.5],
    s: [12.3, 13]
  },
  ic_tenge: {
    xl: [32, 32],
    l: [20.32, 26],
    m: [15.24, 19.5],
    s: [10.16, 13]
  },
  ic_dollar: {
    xl: [32, 32],
    l: [15.6, 26],
    m: [11.7, 19.5],
    s: [7.8, 13]
  },
  ic_som: {
    xl: [32, 32],
    l: [18.57, 26],
    m: [13.93, 19.5],
    s: [9.29, 13]
  },
  ic_atis: {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_loadowner-city-other": {
    xl: [25, 36],
    l: [20, 28],
    m: [14, 20],
    s: [10, 14]
  },
  "ic_loadowner-city-first": {
    xl: [25, 36],
    l: [20, 28],
    m: [14, 20],
    s: [10, 14]
  },
  "ic_loadowner-city-second": {
    xl: [25, 36],
    l: [20, 28],
    m: [14, 20],
    s: [10, 14]
  },
  "ic_loadowner-city-third": {
    xl: [25, 36],
    l: [20, 28],
    m: [14, 20],
    s: [10, 14]
  },
  "ic_dispatcher-city-second": {
    xl: [25, 36],
    l: [20, 28],
    m: [14, 20],
    s: [10, 14]
  },
  "ic_loadowner-country-third": {
    xl: [30.25, 32],
    l: [22.69, 24],
    m: [17, 18],
    s: [11.34, 12]
  },
  "ic_loadowner-country-second": {
    xl: [30.25, 32],
    l: [22.69, 24],
    m: [17, 18],
    s: [11.34, 12]
  },
  "ic_loadowner-country-first": {
    xl: [30.25, 32],
    l: [22.69, 24],
    m: [17, 18],
    s: [11.34, 12]
  },
  "ic_loadowner-country-other": {
    xl: [27.81, 32],
    l: [20.86, 24],
    m: [15.64, 18],
    s: [10.43, 12]
  },
  "ic_winner-badge-2": {
    xl: [25.6, 32],
    l: [20.5, 25.6],
    m: [15.4, 19.2],
    s: [10.2, 12.8]
  },
  "ic_cup-3": {
    xl: [25.7, 30],
    l: [20.5, 24],
    m: [15.4, 18],
    s: [10.29, 12]
  },
  "ic_cup-2": {
    xl: [25.7, 30],
    l: [20.5, 24],
    m: [15.4, 18],
    s: [10.29, 12]
  },
  "ic_firm-document": {
    xl: [28, 34.33],
    l: [20.67, 27.2],
    m: [15.5, 20.4],
    s: [10.34, 13.6]
  },
  "ic_ribbon-3": {
    xl: [29.3, 32],
    l: [22, 24],
    m: [16, 18],
    s: [10, 11.17]
  },
  "ic_ribbon-2": {
    xl: [29.3, 32],
    l: [22, 24],
    m: [16, 18],
    s: [10, 11.17]
  },
  "ic_warehouse-out": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_warehouse-count-out": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_warehouse-out-down": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_warehouse-count-out-down": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_round-table": {
    xl: [32, 32],
    l: [24, 20],
    m: [20, 16],
    s: [12, 10]
  },
  "ic_invite-board-out": {
    xl: [32, 32],
    l: [23, 20],
    m: [16, 14],
    s: [12, 10]
  },
  "ic_invite-board-out-down": {
    xl: [32, 32],
    l: [23, 20],
    m: [16, 14],
    s: [12, 10]
  },
  "ic_booking-out": {
    xl: [32, 32],
    l: [20, 20.5],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_booking-out-down": {
    xl: [32, 32],
    l: [20, 20.5],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_lot-union-out": {
    xl: [32, 32],
    l: [20, 20],
    m: [16, 16],
    s: [12, 12]
  },
  "ic_winner-badge-3": {
    xl: [25.6, 32],
    l: [20.5, 25.6],
    m: [15.4, 19.2],
    s: [10.2, 12.8]
  },
  "ic_ribbon-star": {
    xl: [29.3, 32],
    l: [22, 24],
    m: [16, 18],
    s: [10, 11.17]
  },
  "ic_winner-badge-disabled": {
    xl: [29.3, 32],
    l: [22, 24],
    m: [16, 18],
    s: [10, 11.17]
  },
  "ic_services-filled": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_services-out": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_services-out-down": {
    xl: [32, 32],
    l: [24, 24],
    m: [18, 18],
    s: [12, 12]
  },
  "ic_question-outline": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  },
  "ic_arrows-down-out": {
    xl: [9, 5],
    l: [9, 5],
    m: [6, 3.5],
    s: [6, 3.5]
  },
  "ic_arrows-up-out": {
    xl: [9, 5],
    l: [9, 5],
    m: [6, 3.5],
    s: [6, 3.5]
  },
  "ic_setting-out": {
    xl: [32, 32],
    l: [28, 26.5],
    m: [20, 18.95],
    s: [14, 13.29]
  },
  "ic_plus-out": {
    xl: [32, 32],
    l: [20, 20],
    m: [13.5, 13.5],
    s: [10.07, 10.07]
  },
  "ic_minus-out": {
    xl: [32, 32],
    l: [20, 1.5],
    m: [13.5, 1.5],
    s: [10.07, 1.5]
  },
  "ic_lightning-filled": {
    xl: [32, 32],
    l: [28, 28],
    m: [20, 20],
    s: [14, 14]
  }
};
var defaultSizes = {
  xl: [32, 32],
  l: [19.2, 28.8],
  m: [14.4, 21.6],
  s: [9.6, 14.4]
};
export { iconSizes, sizes, defaultSizes };